import { type PopupPosition } from '@hooks-api/types/dataModel/popup'
import { createPortal } from 'react-dom'
import { PopupDialog } from './components/popupType/PopupDialog'
import { PopupDrawer } from './components/popupType/PopupDrawer'
import { PopupFloating } from './components/popupType/PopupFloating'

export type PopupType = 'center' | 'bottom' | 'floating'

export interface PopupContainerProps {
  popupType?: PopupType
  open: boolean
  onClose?: () => void
  popupKey?: string
  onSubmitPopupImpression?: () => void
  onSubmitPopupClickNoShow?: () => void
  title?: string
  content?: string
  image?: string
  linkUrl?: string
  buttonText?: string
  width?: number
  position?: PopupPosition
  backgroundHidden?: boolean
  onPopupClickEvent?: () => void
}

export const PopupContainer = (props: PopupContainerProps) => {
  const {
    popupType = 'center',
    open,
    onClose,
    popupKey,
    onSubmitPopupImpression,
    onSubmitPopupClickNoShow,
    title,
    content,
    image,
    linkUrl,
    buttonText,
    width,
    position,
    backgroundHidden,
    onPopupClickEvent,
  } = props
  if (!open) return null

  const renderPopupForm = () => {
    if (popupType === 'center') {
      return (
        <PopupDialog
          onClose={onClose}
          open={open}
          popupKey={popupKey}
          onSubmitPopupImpression={onSubmitPopupImpression}
          onSubmitPopupClickNoShow={onSubmitPopupClickNoShow}
          title={title}
          content={content}
          image={image}
          linkUrl={linkUrl}
          buttonText={buttonText}
          popupType={popupType}
          width={width}
          onPopupClickEvent={onPopupClickEvent}
          backgroundHidden={backgroundHidden}
        />
      )
    }
    if (popupType === 'bottom') {
      return (
        <PopupDrawer
          onClose={onClose}
          open={open}
          popupKey={popupKey}
          onSubmitPopupImpression={onSubmitPopupImpression}
          onSubmitPopupClickNoShow={onSubmitPopupClickNoShow}
          title={title}
          content={content}
          image={image}
          linkUrl={linkUrl}
          buttonText={buttonText}
          popupType={popupType}
          width={width}
          onPopupClickEvent={onPopupClickEvent}
          backgroundHidden={backgroundHidden}
        />
      )
    }
    if (popupType === 'floating') {
      return (
        <PopupFloating
          onClose={onClose}
          open={open}
          popupKey={popupKey}
          onSubmitPopupImpression={onSubmitPopupImpression}
          title={title}
          content={content}
          image={image}
          linkUrl={linkUrl}
          popupType={popupType}
          width={width}
          position={position}
          onPopupClickEvent={onPopupClickEvent}
        />
      )
    }
    return null
  }

  return createPortal(
    renderPopupForm(),
    document.body,
  )
}
